import { useQueryClient } from '@tanstack/react-query'

import { getLeadFormConfig } from 'services/lead'
import { GetLeadFormConfigResponse } from 'services/types/lead'
import { STALE_TIME } from 'utils/constants'
import { AppQueryOptions, useAppQuery } from 'hooks/use-app-query'
import useBranch from 'hooks/use-branch'

const queryKeys = {
  all: ['lead-form-config'] as const,
  branchList: (branchId?: string) => [...queryKeys.all, branchId, 'list'] as const,
}

const useLeadFormConfig = (options?: AppQueryOptions<GetLeadFormConfigResponse>) => {
  const { selectedBranch } = useBranch()
  return useAppQuery(queryKeys.branchList(selectedBranch?.branchId), getLeadFormConfig, {
    staleTime: STALE_TIME.branchSetting,
    ...options,
  })
}

export const useInvalidateLeadFormConfig = () => {
  const { selectedBranch } = useBranch()
  const queryClient = useQueryClient()
  const invalidate = () => queryClient.invalidateQueries(queryKeys.branchList(selectedBranch?.branchId))
  return { invalidate }
}

export default useLeadFormConfig
